import React, { useContext, useEffect, useState } from 'react';
import ls from 'local-storage';
import {
  CButton,
  CCard,
  CHeader,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CCol
} from '@coreui/react';
import Moment from 'moment';
import { DateRangePicker } from 'react-date-range';
import { format, isWeekend } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { getTransactionList } from 'src/services/Transactions';
import { DataGrid } from '@mui/x-data-grid';
import formatter from 'src/reusables/formatter';
import { useWindowDimensions } from 'src/reusables/useWindowDimension';
import BoothPicker from 'src/components/BoothPicker';
import DownloadExcel from 'src/reusables/DownloadExcel';
import Authentication, { AUTH_KEY } from 'src/utils/auth/Authentication';
import { AuthContext } from 'src/App';
import DataTablePagination from 'src/components/DataTablePagination';

const DEFAULT_PAGINATION_MODEL = {
  page: 0,
  pageSize: 10
}

function TransactionList() {
  const [drModal, setDrModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [renderCounter, setRenderCounter] = useState(0);
  const [tableLoading, setTableLoading] = useState(true)
  const [rowCount, setRowCount] = useState(0)
  const [paginationModel, setPaginationModel] = useState(DEFAULT_PAGINATION_MODEL)

  const endDay = Moment(new Date()).format('YYYY-MM-DD');
  const max = new Date(endDay);
  const startDay = Moment(new Date('Jan 1 2023')).format('YYYY-MM-DD');

  const [trxRows, setTrxRows] = useState([]);
  const [excelRows, setExcelRows] = useState([]);

  const [trxColumns, setTrxColumns] = useState([]);
  const [excelColumns, setExcelColumns] = useState([]);

  const navigate = useNavigate();
  const Auth = useContext(AuthContext)
  const { height, width, comparison } = useWindowDimensions();

  const [dateRange, setDateRange] = useState([{
    startDate: new Date(`${Moment(new Date()).startOf('month')}`),
    endDate: new Date()
  }])

  async function fetchTransactionList(dateFrom, dateTo, id, page, pageSize) {
    const res = await getTransactionList(dateFrom, dateTo, id ?? "", page, pageSize)

    setRowCount(res.count)
    const rows = res.data && res.data.map((item, i) => {
      const data = {
        id: i,
        price: formatter("currency", item?.price ?? 0),
        discount: formatter("currency", item?.discount ?? 0),
        timeout: item.timeout === 1 || item.timeout === "1" ? "Yes" : "No",
        grandTotal: formatter("currency", item?.grand_total ?? 0),
        frameName: item.frameName,
        trxId: item.id,
        paidAt: formatter("completeDate", item?.paidAt ?? "0000-00-00 00:00:00"),
        doneAt: item?.doneAt !== "0000-00-00 00:00:00" ? formatter("completeDate", item?.doneAt ?? "0000-00-00 00:00:00") : "Not Printed Yet",
        merchantName: `${item.merchant_name} - ${item.booth_id}`,
        happyHour: item.is_happy_hour === 1 || item.is_happy_hour === "1" ? "Yes" : "No"
      }

      const excelData = {
        ...data,
        voucherCode: item.voucher_code,
        imageURL: item.image_url
      }

      setExcelRows(prev => [...prev, excelData])

      return data

    })

    setTrxRows(rows)

    const columns = [
      { field: 'trxId', headerName: 'Transaction ID', width: "150" },
      { field: 'merchantName', headerName: 'Merchant', width: "150" },
      { field: 'price', headerName: 'Price', width: "150" },
      { field: 'discount', headerName: 'Discount', width: "150" },
      { field: 'grandTotal', headerName: 'Grand Total', width: "150" },
      { field: 'timeout', headerName: 'Timeout', width: "150" },
      { field: 'happyHour', headerName: 'Happy Hour', width: "150" },
      { field: 'frameName', headerName: 'Frame', width: "150" },
      { field: 'paidAt', headerName: 'Paid At', width: "200" },
      { field: 'doneAt', headerName: 'Done At', width: "200" },
    ]

    let beforeExcel = [...columns]

    let afterExcel = beforeExcel.splice(4)

    let afterExcel2 = beforeExcel.splice(4)

    const excel = beforeExcel.concat([{ field: 'voucherCode', headerName: 'Voucher Code', width: "200" }]).concat(afterExcel).concat([{ field: 'imageURL', headerName: 'Image URL', width: "200" }]).concat(afterExcel2)

    setExcelColumns(excel)

    setTrxColumns(columns)
    setTableLoading(false)
  }

  function toSQLDateFormat(date) {
    return Moment(new Date(date)).format('YYYY-MM-DD');
  }

  function handleRowClick(params) {
    if (!(localStorage.getItem('orgID') == 0 && Auth.isDenied(Auth.role[AUTH_KEY.transactions_detail]))) {
      ls.set("state", params.row)
      // navigate('/transaction-details', { state: params.row });
      if (ls.get("state")) {
        window.open('/transaction-details', "_blank");
      }
    }
  }

  function customDayContent(day) {
    let extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: '5px',
            width: '5px',
            borderRadius: '100%',
            background: 'orange',
            position: 'absolute',
            top: 2,
            right: 2
          }}
        />
      );
    }
  }

  function fetchTransactionsListInterface(page, pageSize) {
    setTableLoading(true)
    const newStartDay = formatter("SQLDate", dateRange[0].startDate)
    const newEndDay = formatter("SQLDate", dateRange[0].endDate)
    // if((refetch && renderCounter > 0) || renderCounter === 0){
    fetchTransactionList(newStartDay, newEndDay, ls.get("booth")?.id ?? "", page, pageSize)
  }
  useEffect(() => {
    fetchTransactionsListInterface(paginationModel.page, paginationModel.pageSize)
  }, [paginationModel, dateRange])

  useEffect(() => {
    setRefetch(false)
    setPaginationModel(DEFAULT_PAGINATION_MODEL)
    // } else {
    // }

    setRenderCounter(renderCounter + 1)
    
  }, [dateRange])
  

  function customDayContent(day) {
    let extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: "5px",
            width: "5px",
            borderRadius: "100%",
            background: "orange",
            position: "absolute",
            top: 2,
            right: 2,
          }}
        />
      )
    }
    return (
      <div>
        <span
          style={{
            fontWeight: "600"
          }}
        >
          {format(day, "d")}
        </span>
      </div>
    )
  }

  return (
    <div style={{ color: "black" }}>
      <CRow>
        <CCol>
          <CButton
            className="ml-3 mb-3 btn btn-dark"
            style={{ backgroundColor: "#4E5B97", border: "none" }}
            hover="true"
            onClick={() => {
              setDrModal(!drModal);
            }}
          >
            <div>
              {Moment(dateRange[0].startDate).format("ll")}
              {" - "}
              {Moment(dateRange[0].endDate).format("ll")}
            </div>
          </CButton>
        </CCol>
        <CCol>
          <BoothPicker />
        </CCol>
      </CRow>

      <CModal
        visible={drModal}
        style={{
          width: comparison < 1 ? "" : "fit-content",
          overflowX: comparison < 1 ? "scroll" : "visible"
        }}
      >
        <CModalHeader
          style={{
            width: comparison < 1 ? `${85 * 1 / comparison}vw` : ""
          }}
        >
          <CModalTitle>Date Range</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol xs="12" lg="10">
            <DateRangePicker
              onChange={
                (item) => {
                  setDateRange([item.range1])
                  ls.set("dateRange", item.range1)
                }
              }
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              maxDate={max}
              ranges={dateRange}
              direction="vertical"
              weekStartsOn={1}
              calendarFocus="backwards"
              preventSnapRefocus={true}
              rangeColors={['#4E5B97']}
              dayContentRenderer={customDayContent}
            />
          </CCol>
        </CModalBody>
        <CModalFooter
          style={{
            width: comparison < 1 ? `${85 * 1 / comparison}vw` : ""
          }}
        >
          <CButton style={{ backgroundColor: "#4E5B97", border: "none" }} onClick={() => setDrModal(!drModal)}>
            Close
          </CButton>
          <CButton style={{ backgroundColor: "#4E5B97", border: "none" }} onClick={() => {
            setRefetch(true)
            setDrModal(false)
          }}>
            OK
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal
        visible={drModal}
        style={{
          width: comparison < 1 ? '' : 'fit-content',
          overflowX: comparison < 1 ? 'scroll' : 'visible'
        }}
      >
        <CModalHeader
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CModalTitle>Date Range</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol xs="12" lg="10">
            <DateRangePicker
              onChange={(item) => {
                setDateRange([item.range1]);
                ls.set('dateRange', item.range1);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              maxDate={max}
              ranges={dateRange}
              direction="vertical"
              weekStartsOn={1}
              calendarFocus="backwards"
              preventSnapRefocus={true}
              rangeColors={['#4E5B97']}
              dayContentRenderer={customDayContent}
            />
          </CCol>
        </CModalBody>
        <CModalFooter
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => {
              setRefetch(true);
              setDrModal(false);
            }}
          >
            OK
          </CButton>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => setDrModal(!drModal)}
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal>

      <CHeader
        style={{ fontSize: '30px', marginTop: '3vh', padding: '1vh 2vw' }}
      >
        <CCol xs='8' >
          Transaction List:{' '}
        </CCol>
        <CCol xs='4' style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) &&
            <DownloadExcel
              rows={excelRows}
              columns={excelColumns}
              dateFrom={formatter("SQLDate", dateRange[0].startDate)}
              dateTo={formatter("SQLDate", dateRange[0].endDate)}
              excelName='Transactions Report'
              config={{ width: '20' }}
            />
          }
        </CCol>
      </CHeader>
      <CCard>
        <DataTablePagination
          rows={trxRows}
          columns={trxColumns}
          rowCount={rowCount}
          loading={tableLoading}
          onRowClick={handleRowClick}
          onPageChange={fetchTransactionsListInterface}
          style={{ textAlign: 'center' }}
        />
        {/* <DataGrid
          rows={trxRows}
          columns={trxColumns}
          onRowClick={handleRowClick}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 }
            }
          }}
          pageSizeOptions={[5, 10, 20, 25]}
          checkboxSelection
          style={{ textAlign: 'center' }}
        /> */}
      </CCard>
    </div>
  );
}

export default TransactionList;
